/*!
 * Created by netlogix GmbH & Co. KG
 *
 * @copyright netlogix GmbH & Co. KG
 */

import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Tour, UserRole } from '@shared/models';
import { ToursService } from '@tours/services/tours.service';
import { NgxPermissionsService } from 'ngx-permissions';
import { from, of, Subscription } from 'rxjs';
import { catchError, delay, map, switchMap, tap } from 'rxjs/operators';

@Component({
    selector: 'app-tour-notes-list',
    templateUrl: './tour-notes-list.component.html',
    styleUrls: ['./tour-notes-list.component.scss'],
    standalone: false
})
export class TourNotesListComponent implements OnInit, OnDestroy {
  public tour: Tour;
  private routeSubscription: Subscription;

  constructor(
    private activatedRoute: ActivatedRoute,
    private toursService: ToursService,
    private changeDetector: ChangeDetectorRef,
    private permissionsService: NgxPermissionsService,
  ) { }

  ngOnInit(): void {
    this.routeSubscription = this.activatedRoute.params.pipe(
      map(params => params.tourId),
      switchMap(tourId => this.toursService.getTour(tourId)),
      tap(tour => {
        this.tour = tour;
        this.changeDetector.detectChanges(); // force rerender with tour data before printing
      }),
      delay(100),
      tap(_ => window.print()),
      switchMap(tour => from(this.permissionsService.hasPermission(UserRole.User)).pipe(
        switchMap(canWrite => {
          if (false === canWrite) {
            return of(tour);
          }

          tour.printed = true;
          return this.toursService.updateTour(tour);
        })
      )),
      tap(_ => window.close()),
      catchError((error) => {
        window.close();
        return error;
      })
    ).subscribe();
  }

  ngOnDestroy(): void {
    this.routeSubscription.unsubscribe();
  }
}
